export const PARAM_NAMES = {
	XLTOVL: 'xlToVl',
	BEDROCK_REDIRECT_REASON: 'redirect_reason',
	REDIRECT: 'redirect',
};
